import { UIUtilsEjsVariables } from '../../shared/scripts/UIUtilsEjsVariables.ts';
import { EntryHomepage } from './EntryHomepage.ts';
export class EntryWeb extends EntryHomepage {
    async initialize() {
        await super.initialize();
    }
    constructor(){
        super();
        void this.initialize();
    }
}
if (!UIUtilsEjsVariables.isUserOnDiscord) new EntryWeb();
